import React from "react";
import EditableText from "../edit/EditableText";
import PageCopyright from "../edit/PageCopyright";
import { BODY_STYLE, PAGE_TITLE_STYLE } from "../edit/textStyles";

function WomenMinistryPage() {
  return (
    <div className="main-content" style={{ maxWidth: 900, margin: "0 auto", padding: 24 }}>
      <EditableText id="women-ministry.title" defaultContent="妇女事工" defaultStyle={PAGE_TITLE_STYLE} />
      <section style={{ margin: "32px 0" }}>
        <EditableText
          id="women-ministry.body"
          defaultContent={"生命河教会妇女事工通过组织妇女学习《圣经》来认识上帝，透过彼此关怀来互相鼓励。\n根据不同需要，设立不同程度《圣经》学习团契：百合花团契；郁金香团契；橄榄树团契。\n同时也透过探访和郊游来加深大家的彼此了解。"}
          defaultStyle={BODY_STYLE}
        />
      </section>
      <PageCopyright pageId="women-ministry" />
    </div>
  );
}

export default WomenMinistryPage;
